import { render, staticRenderFns } from "./CpzxDetails.vue?vue&type=template&id=2f22bb3d&scoped=true"
import script from "./CpzxDetails.vue?vue&type=script&lang=js"
export * from "./CpzxDetails.vue?vue&type=script&lang=js"
import style0 from "./CpzxDetails.vue?vue&type=style&index=0&id=2f22bb3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22bb3d",
  null
  
)

export default component.exports